export const PLAN_DISPLAY_NAMES = {
    STARTER: "Starter",
    PROFESSIONAL_LITE: "Professional",
    PROFESSIONAL_WITHOUT_SMS: "Professional (without sms)",
    PROFESSIONAL: "Professional",
    PROFESSIONAL_PLUS: "Professional",
    PROFESSIONAL_PLUS_WITHOUT_SMS: "Professional (without sms)",
    DOORDASH_FLEX_FULFILMENT: "Doordash Flex Fulfilment",
    ENTERPRISE: "Enterprise",
    TRIAL_PROFESSIONAL: "Trial (professional)",
    BRANDED_PREMIUM: "Branded Premium",
    BRANDED_PREMIUM_WITHOUT_SMS: "Branded Premium (without sms)",
    BRANDED_PREMIUM_PLUS: "Branded Premium",
    BRANDED_PREMIUM_CUSTOM: "Branded Premium",
    BRANDED_PREMIUM_MARKETING: "Branded Premium",
    BRANDED_ELITE: "Branded Elite",
    BRANDED_ELITE_LITE: "Branded Elite",
    BRANDED_ELITE_PLUS: "Branded Elite",
    BRANDED_ELITE_UNLIMITED: "Branded Elite",
    BUSINESS_ADVANCED: "Business Advanced",
    BUSINESS_ADVANCED_PLUS: "Business Advanced",
}

export const PLAN_PAID_MAPPING = {
    "Enterprise": true,
    "Business Advanced": true,
    "Branded Elite": true,
    "Branded Premium": true,
    "Branded Premium (without sms)": true,
    "Doordash Flex Fulfilment": true,
    "Professional": true,
    "Professional (without sms)": true,
    "Trial (professional)": false,
    "Starter": false,
}

export const planOrder = [
    "Enterprise",
    "Business Advanced",
    "Branded Elite",
    "Branded Premium",
    "Branded Premium (without sms)",
    "Doordash Flex Fulfilment",
    "Professional",
    "Professional (without sms)",
    "Trial (professional)",
    "Starter",
]

export const getDisplayName = (plan) => {
    if (plan in PLAN_DISPLAY_NAMES)
        return PLAN_DISPLAY_NAMES[plan];
    else 
        return plan;
}